import creditCard from "./creditCard";
import subscription from "./subscription";
import promo from "./promo";

export default {
  ...subscription,
  ...creditCard,
  ...promo,
};
